import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(
        public auth: AuthService,
        public router: Router
    ) {}

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.auth.isAuthenticated()) {
            this.addRedirect(state);
            this.router.navigate(['/login']);
            return false;
        }
        return true;
    }

    private addRedirect(state): void {
        if (!localStorage.getItem('redirect_url')) {
            if (state.url.indexOf('?') > -1) {
                const split = state.url.split('?');
                localStorage.setItem('redirect_query', split[1]);
                localStorage.setItem('redirect_url', split[0]);
            } else {
                localStorage.setItem('redirect_url', state.url);
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth-guard.service.ts